const StatusIndicator = ({ backgroundColor }: { backgroundColor: string }) => {
  return (
    <div
      style={{ backgroundColor }}
      className="h-[12px] w-[12px] rounded-full "
    ></div>
  );
};
export default StatusIndicator;
